import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from "styled-components";
import {
  DatePicker,
  DateRenderer,
  DefaultButton,
  normalizeDate,
  WarningButton
} from "../../../components";

const editableStyles = css`
  :hover {
    cursor: ${props => props.editing ? 'inherit' : 'pointer'};
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    background-color: rgba(240,240,240,0.3);
  }
`;

const Container = styled.div`
  margin-bottom: 1rem;
  & .row { margin-bottom: .5rem; }
  & .property { 
    font-weight: bold;
    text-align: right;
  }
  
  border: 1px solid ${props => props.editing ? '#f0f0f0' : 'transparent'};
  background-color: ${props => props.editing ? 'rgba(240,240,240,0.3)' : 'inherit'} ;
  padding: 1rem; 
  ${props => props.editable && editableStyles}
`;


const PatientIconContainer = styled.button`
border: none; 
background: transparent;
`
class RecordInfo extends React.PureComponent {
  state = {
    id: '',
    name: '',
    medicaidId: '',
    editing: false,
    showEditHint: false,
  };

  componentDidMount() {
    const { record } = this.props;
    this.setRecordData(record);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.record !== this.props.record) {
      this.setRecordData(nextProps.record)
    }
  }

  renderStatus = () => {
    const { editable, period } = this.props;

    return !editable ?
      <div className="row">
        <div className="property col-sm-3">Upload Status:</div>
        <div className="col-sm-9">{period.facilityStatus}</div>
      </div>
      : <div className="row">
        <div className="property col-sm-3">Period Status:</div>
        <div className="col-sm-9">{period.quarterlyStatus}</div>
      </div>
  }

  setRecordData = ({ id, name, dateOfBirth, admissionDate, medicaidId }) => this.setState({
    id,
    name,
    dateOfBirth,
    admissionDate,
    medicaidId
  });

  toggleEditor = (cancel) => {
    return this.setState(st => ({ editing: !st.editing, showEditHint: false }), () => {
      cancel && this.setRecordData(this.props.record);
    });
  };
  showEditHint = () => this.setState({ showEditHint: true });
  hideEditHint = () => this.setState({ showEditHint: false });
  setValue = name => value => this.setState({ [name]: value });
  saveRecord = () => {
    this.props.onSave(this.state).then(res => {
      if (res.errors) {
        this.setRecordData(this.props.record);
      } else {
        this.setState({ editing: false });
      }
    })
  };

  showEditor = () => {
    if (this.props.editable && !this.state.editing)
      this.toggleEditor();
  };

  navigateToPatientDetails = () => {
    this.props.searchPatient(this.state.name, normalizeDate(this.state.dateOfBirth));
  }

  render() {
    const { period, record, editable } = this.props;
    const { editing } = this.state;
    console.log('record', record);

    return (
      <Container
        editable={editable}
        editing={editing}
      >
        <div className="row">
          <div className="col-md-10">
            <div className="row">
              <div className="property col-sm-3">Period:</div>
              <div className="col-sm-9">{period.description}</div>
            </div>
            {this.renderStatus()}
            <div className="row">
              <div className="property col-sm-3">Facility:</div>
              <div className="col-sm-9">{record.facilityName}</div>
            </div>
            <div className="row">
              <div className="property col-sm-3">Patient Name:</div>
              <div className="col-sm-7">{
                editing ? (
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.name}
                    onChange={({ currentTarget: { value } }) => this.setValue('name')(value)} />
                ) : (
                  <span className="editable">{this.state.name}
                    {this.props.searchPatient &&
                      <PatientIconContainer
                        title="View Patient Details"
                        type='button'
                        onClick={() => this.navigateToPatientDetails()}>
                        <i class="fa fa-user" style={{ color: "darkblue" }} aria-hidden="true" ></i>
                      </PatientIconContainer>
                    }
                  </span>
                )
              }</div>
            </div>
            <div className="row">
              <div className="property col-sm-3">Medicaid ID:</div>
              <div className="col-sm-7">
                {editing ? (
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.medicaidId}
                    maxLength={10}
                    onChange={({ currentTarget: { value } }) => this.setValue('medicaidId')(value)} />
                ) : (
                  <span className="editable">{this.state.medicaidId}</span>
                )}
              </div>
            </div>
            <div className="row">
              <div className="property col-sm-3">Date of Birth:</div>
              {editing ? (
                <div className="col-sm-4">
                  <DatePicker
                    onChange={this.setValue("dateOfBirth")}
                    value={normalizeDate(this.state.dateOfBirth)}
                  />
                </div>
              ) : (
                <div className="col-sm-9 editable">
                  <DateRenderer value={normalizeDate(record.dateOfBirth)} />
                </div>
              )
              }
            </div>
            <div className="row">
              <div className="property col-sm-3">Admit Date:</div>
              {editing ? (
                <div className="col-sm-4">
                  <DatePicker
                    onChange={this.setValue("admissionDate")}
                    value={normalizeDate(this.state.admissionDate)}
                  />
                </div>
              ) : (
                <div className="col-sm-9 editable">
                  <DateRenderer value={normalizeDate(record.admissionDate)} />
                </div>
              )
              }
            </div>

          </div>
          <div className="col-md-2">
            {editable && (
              <WarningButton style={{ width: 60 }} onClick={this.showEditor}>Edit</WarningButton>
            )}
          </div>
        </div>
        {editing && (
          <div className="row">
            <div className="col-md-1 col-md-offset-9">
              <DefaultButton onClick={() => this.toggleEditor(true)}>Cancel</DefaultButton>
            </div>
            <div className="col-md-2">
              <WarningButton style={{ width: 60 }} onClick={this.saveRecord}>Save</WarningButton>
            </div>
          </div>
        )}
      </Container>
    )
  }
}

RecordInfo.propTypes = {
  record: PropTypes.object.isRequired,
  period: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  editable: PropTypes.bool,
};

export default RecordInfo;



// WEBPACK FOOTER //
// ./src/modules/record/components/RecordInfo.js